import React from "react";
import Messages from "./messages";

const ChatWindow = () => {
  // optional: get context from localStorage
  const chatContext = JSON.parse(localStorage.getItem("chatContext") || "{}");

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        background: "#f5f5f5",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Messages
        initialRFQ={chatContext.rfq}
        initialSupplier={chatContext.supplier}
        chatContext={chatContext}
      />
    </div>
  );
};

export default ChatWindow;
// import React, { useState } from "react";
// import { Rnd } from "react-rnd";
// import Messages from "./messages";

// const ChatWindow = () => {
//   const chatContext = JSON.parse(localStorage.getItem("chatContext") || "{}");
//   const [size, setSize] = useState({ width: 600, height: 650 });

//   return (
//     <div
//       style={{
//         height: "100vh",
//         width: "100vw",
//         background: "#f5f5f5",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//       }}
//     >
//       <Rnd
//         default={{
//           x: 0,
//           y: 0,
//           width: size.width,
//           height: size.height,
//         }}
//         minWidth={360}
//         minHeight={400}
//         bounds="window"
//         onResizeStop={(e, direction, ref, delta, position) => {
//           setSize({
//             width: ref.offsetWidth,
//             height: ref.offsetHeight,
//           });
//         }}
//         style={{
//           background: "#fff",
//           borderRadius: "14px",
//           boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
//           display: "flex",
//           flexDirection: "column",
//           overflow: "hidden",
//         }}
//       >
//         <Messages
//           initialRFQ={chatContext.rfq}
//           initialSupplier={chatContext.supplier}
//           chatContext={chatContext}
//         />
//       </Rnd>
//     </div>
//   );
// };

// export default ChatWindow;
